import React from "react";

const Loader = ({ className: styledClassName = "" }) => {
  return (
    <div className={`${styledClassName}`}>
      <div className="loader">
        <div className="loader-inner ball-pulse">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
